import { Box, SvgIcon, Typography } from '@mui/material';
import FileBot from 'assets/file-bot.svg';
import { bool } from 'prop-types';
import React from 'react';
import { I18n } from 'utils/i18n';

const TemplateListHelp = ({ isEmpty = false }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 3 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'center',
          width: '50%',
        }}
      >
        <SvgIcon sx={theme => ({ fontSize: 96, color: theme.palette.greyBlue })}>
          <FileBot />
        </SvgIcon>
        <Typography variant="h5" component="h1" sx={{ m: '20px 0', whiteSpace: 'pre-line' }}>
          {I18n.t('HrBot.Hello human')}
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'center',
          width: '50%',
        }}
      >
        {!isEmpty ? (
          <Box
            sx={theme => ({
              background: theme.palette.secondary.ultraUltraLight,
              border: `1px solid ${theme.palette.secondary.extraLight}`,
              borderRadius: '6px',
              p: 4,
              '& ul': {
                padding: '0 0 0 40px',
                listStylePosition: 'outside',
                marginBottom: 0,
                color: theme.palette.secondary.light,
              },
            })}
          >
            <Typography>
              <strong>{I18n.t('HrBot.infoBox.sendTitle')}</strong>
            </Typography>
            <ul>
              {[1, 2, 3, 4].map(char => (
                <li key={`char.${char}`}>
                  <Typography
                    sx={[
                      {
                        display: 'inline',
                      },
                      theme => ({ color: theme.palette.black, verticalAlign: 'middle' }),
                    ]}
                  >
                    {I18n.t(`HrBot.infoBox.sendItems.${char}`)}
                  </Typography>
                </li>
              ))}
            </ul>
            <Typography sx={{ mt: 3 }}>
              <strong>{I18n.t('HrBot.infoBox.newTemplateTitle')}</strong>
            </Typography>
            <ul>
              {[1, 2, 3, 4].map(char => (
                <li key={`char.${char}`}>
                  <Typography
                    sx={[
                      {
                        display: 'inline',
                      },
                      theme => ({ color: theme.palette.black, verticalAlign: 'middle' }),
                    ]}
                  >
                    {I18n.t(`HrBot.infoBox.newTemplateItems.${char}`)}
                  </Typography>
                </li>
              ))}
            </ul>
          </Box>
        ) : (
          <Box
            sx={theme => ({
              background: theme.palette.secondary.ultraUltraLight,
              border: `1px solid ${theme.palette.secondary.extraLight}`,
              borderRadius: '6px',
              p: 4,
              '& ul': {
                padding: '0 0 0 40px',
                listStylePosition: 'outside',
                marginBottom: 0,
                color: theme.palette.secondary.light,
              },
            })}
          >
            <Typography>
              <strong>{I18n.t('HrBot.infoBoxEmpty.title')}</strong>
            </Typography>
            <ul>
              {[1, 2, 3].map(char => (
                <li key={`char.${char}`}>
                  <Typography
                    sx={[
                      {
                        display: 'inline',
                      },
                      theme => ({ color: theme.palette.black, verticalAlign: 'middle' }),
                    ]}
                  >
                    {I18n.t(`HrBot.infoBoxEmpty.characteristics.${char}`)}
                  </Typography>
                </li>
              ))}
            </ul>
            <Typography sx={{ mt: 3 }}>{I18n.t('HrBot.infoBoxEmpty.footer')}</Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

TemplateListHelp.propTypes = {
  isEmpty: bool,
};

export default TemplateListHelp;
